import React, { useMemo, PropsWithChildren, useState } from 'react';

import { defaultError, errorMap } from './error-map/map';
import { ErrorHandlerContextValue, ErrorState } from './types';
import { ErrorHandlerContext, ErrorPropsContext } from './context';

interface ErrorBondaryContextProps {
    errorMap: typeof errorMap;
}

export const ErrorBondaryContext: React.FC<PropsWithChildren<ErrorBondaryContextProps>> = ({
    errorMap,
    children,
}) => {
    const [error, setError] = useState<ErrorState>({
        name: null,
    });

    const ErrorComponent =
        error.name === null ? null : errorMap[error.name] ?? errorMap[defaultError];

    const errorHandlerSetterContextValue: ErrorHandlerContextValue = useMemo(
        () => ({
            handleError: (name, props) => {
                setError((oldError) => ({ ...oldError, name, ...props }));
            },
            cleanError: () => {
                setError((oldError) => ({ ...oldError, name: null }));
            },
            addErrorData: (props) => {
                setError((oldError) => ({ ...oldError, ...props }));
            },
        }),
        []
    );

    return (
        <ErrorHandlerContext.Provider value={errorHandlerSetterContextValue}>
            <ErrorPropsContext.Provider value={error}>
                {ErrorComponent !== null && <ErrorComponent />}
                {children}
            </ErrorPropsContext.Provider>
        </ErrorHandlerContext.Provider>
    );
};
